import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

/** Libraries */
import React, { useCallback, useEffect, useState } from 'react';

/** Components */
import SlideModal from '@components/Modals/Slide';
import { CustomHeader as Header } from '@scenes/LoginPage/LoginForm/CustomHeader';

/* State: client */
import { useAppOpenSlideModalLogin, useAppStoreActions } from '@store/client/store.app';

/* Hooks */
import usePrevious from '@hooks/usePrevious';

/** Dynamic Components */
const ResetPasswordPage = dynamic(() => import('@scenes/ResetPasswordPage'), { ssr: false });
const LoginForm = dynamic(() => import('@scenes/LoginPage/LoginForm/LoginForm'), { ssr: false });

type LoginModalProps = {
  openModal?: boolean;
  showCloseIcon?: boolean;
  handleModalClose?: BaseAnyFunction;
  showLogo?: boolean;
  CustomHeader?: React.ElementType;
  /* This is to remove links, register etc... */
  minimalView?: boolean;
  /* This would show the top logo/close button */
  showHeader?: boolean;
};

const LoginModal = ({
  openModal = false,
  handleModalClose,
  showCloseIcon = false,
  showLogo = true,
  CustomHeader,
  minimalView = false,
  showHeader = true,
}: LoginModalProps) => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const router = useRouter();
  const currentPath = usePrevious(router.asPath);

  /* State: Global App */
  const { setOpenSlideModalLogin } = useAppStoreActions();
  const openSlideModalLogin = useAppOpenSlideModalLogin();

  /* Close the modal */
  const handleClose = useCallback(() => {
    setOpenSlideModalLogin(false);
  }, [setOpenSlideModalLogin]);

  /* If the url chagnes, close this modal */
  useEffect(() => {
    if (currentPath && currentPath !== router.asPath) handleClose();
  }, [router.asPath, currentPath, handleClose]);

  if (!openSlideModalLogin && !openModal) return null;

  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
  };

  const handleSuccess = (arg: any = false) => {
    /**
     * 1. Does container page want to do something extra?
     *    a. pass into login modal cb
     * 2. close the modal via global app state
     */
    /* 1. */
    handleModalClose?.(arg);
    /* 2. */
    handleClose();
  };

  return (
    <SlideModal
      open={openSlideModalLogin || openModal}
      showCloseIcon={showCloseIcon}
      handleClose={handleSuccess}
      showLogo={showLogo}
      customHeader={CustomHeader || Header}
    >
      {(openSlideModalLogin || openModal) && (
        <>
          {!showForgotPassword ? (
            <LoginForm modalView minimalView={minimalView} onForgotPasswordClick={handleForgotPasswordClick} onSuccessCallback={handleSuccess} />
          ) : (
            <ResetPasswordPage onSignInClick={() => setShowForgotPassword(false)} />
          )}
        </>
      )}
    </SlideModal>
  );
};

export default LoginModal;
